import { render, staticRenderFns } from "./SettingsPaymentCheckout.vue?vue&type=template&id=53a97f59&scoped=true&lang=pug&"
import script from "./SettingsPaymentCheckout.vue?vue&type=script&lang=js&"
export * from "./SettingsPaymentCheckout.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPaymentCheckout.vue?vue&type=style&index=0&id=53a97f59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a97f59",
  null
  
)

/* custom blocks */
import block0 from "./SettingsPaymentCheckout.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VDivider,VRow,VSpacer})
